

import { greyTheme as appGreyTheme } from './greyTheme';
import { whiteTheme as appWhiteTheme } from './whiteTheme';
import { blackTheme as appBlackTheme } from './blackTheme';
import { additionalWhite1 } from './additionalWhiteTheme_1';
import { additionalWhite_2 } from './additionalWhiteTheme_2';
import { additionalGreyTheme } from './additionalGreyTheme';
import appBlueTheme from './blueTheme';

import { UIThemes, mergeThemes, ApplicationTheme as uiApplicationTheme } from '@brg/ui';
import { greenawardTheme } from './greenawardTheme';
import { jhonataTheme as jhonataAppTheme } from './jhonataTheme';

const greyTheme = mergeThemes(uiApplicationTheme.grey, appGreyTheme, UIThemes.geograffee)
const whiteTheme = mergeThemes(uiApplicationTheme.white, appWhiteTheme, UIThemes.white)
const additionalWhite__1 = mergeThemes(uiApplicationTheme.white, additionalWhite1, UIThemes.white)
const greenawardThemes = mergeThemes(uiApplicationTheme.white, greenawardTheme, UIThemes.white)
const blackTheme = mergeThemes(uiApplicationTheme.black, appBlackTheme, UIThemes.black)
const blueTheme = mergeThemes(uiApplicationTheme.blue, appBlueTheme, UIThemes.creative)

const jhonataTheme = mergeThemes(uiApplicationTheme.zeland, jhonataAppTheme, UIThemes.zeland)

export type ApplicationThemeT = typeof greyTheme;

declare module 'styled-components' {
    export interface DefaultTheme extends ApplicationThemeT {}
}

export const ApplicationTheme = {
    grey: greyTheme as ApplicationThemeT,
    white: whiteTheme as ApplicationThemeT,
    black: blackTheme as ApplicationThemeT,
    additionalWhite_1: additionalWhite__1 as ApplicationThemeT,
    additionalWhite_2: mergeThemes(additionalWhite_2, UIThemes.white) as ApplicationThemeT,
    additionalGreyTheme: mergeThemes(uiApplicationTheme.grey, additionalGreyTheme, UIThemes.geograffee) as ApplicationThemeT,
    greenawardThemes: greenawardThemes as ApplicationThemeT ,
    blue: blueTheme as ApplicationThemeT,
    jhonata: jhonataTheme
};


import { greyTheme as appGreyTheme } from './greyTheme';
import { whiteTheme as appWhiteTheme } from './whiteTheme';
import { blackTheme as appBlackTheme } from './blackTheme';
import { additionalWhite1 } from './additionalWhiteTheme_1';
import { additionalWhite_2 } from './additionalWhiteTheme_2';
import { additionalGreyTheme } from './additionalGreyTheme';
import appBlueTheme from './blueTheme';

import { UIThemes, mergeThemes, ApplicationTheme as uiApplicationTheme } from '@brg/ui';
import { greenawardTheme } from './greenawardTheme';
import { jhonataTheme as jhonataAppTheme } from './jhonataTheme';

const greyTheme = mergeThemes(uiApplicationTheme.grey, appGreyTheme, UIThemes.geograffee)
const whiteTheme = mergeThemes(uiApplicationTheme.white, appWhiteTheme, UIThemes.white)
const additionalWhite__1 = mergeThemes(uiApplicationTheme.white, additionalWhite1, UIThemes.white)
const greenawardThemes = mergeThemes(uiApplicationTheme.white, greenawardTheme, UIThemes.white)
const blackTheme = mergeThemes(uiApplicationTheme.black, appBlackTheme, UIThemes.black)
const blueTheme = mergeThemes(uiApplicationTheme.blue, appBlueTheme, UIThemes.creative)

const jhonataTheme = mergeThemes(uiApplicationTheme.zeland, jhonataAppTheme, UIThemes.zeland)

export type ApplicationThemeT = typeof greyTheme;

declare module 'styled-components' {
    export interface DefaultTheme extends ApplicationThemeT {}
}

export const ApplicationTheme = {
    grey: greyTheme as ApplicationThemeT,
    white: whiteTheme as ApplicationThemeT,
    black: blackTheme as ApplicationThemeT,
    additionalWhite_1: additionalWhite__1 as ApplicationThemeT,
    additionalWhite_2: mergeThemes(additionalWhite_2, UIThemes.white) as ApplicationThemeT,
    additionalGreyTheme: mergeThemes(uiApplicationTheme.grey, additionalGreyTheme, UIThemes.geograffee) as ApplicationThemeT,
    greenawardThemes: greenawardThemes as ApplicationThemeT ,
    blue: blueTheme as ApplicationThemeT,
    jhonata: jhonataTheme
};
